<template>
  <v-app>
    <v-app-bar app v-if="isAuthenticated" elevation="0">
      <v-container class="pa-0 fill-height">
        <router-link :to="{ name: 'Dashboard' }">
          <v-img class="mx-2" :src="require('./assets/logo.svg')" max-width="120" contain />
        </router-link>
        <!-- -->
        <v-spacer />

        <v-btn
          @click="exportXLS"
          small
          color="primary"
          elevation="0"
          :loading="loading"
          v-if="routeName === 'Dashboard'"
          >Export Shops</v-btn
        >
        <v-btn @click="importFile" small color="primary" elevation="0" style="margin-left: 15px">Import File</v-btn>
        <v-btn icon @click="logout">
          <v-icon color="primary">mdi-logout</v-icon>
        </v-btn>
      </v-container>
    </v-app-bar>

    <!-- Sizes your content based upon application components -->
    <v-main>
      <!-- Provides the application the proper gutter -->
      <v-container>
        <!-- If using vue-router -->
        <v-fade-transition mode="out-in">
          <router-view />
        </v-fade-transition>
      </v-container>
    </v-main>
  </v-app>
</template>

<script lang="ts">
import { Component, Vue, Watch } from 'vue-property-decorator'
import moment from 'moment'

@Component
export default class App extends Vue {
  loader: any = null
  loading = false

  @Watch('loader')
  setLoading() {
    if (this.loader === 'loading') {
      this.loading = true
    } else {
      this.loading = false
      this.loader = null
    }
  }

  get isAuthenticated() {
    return this.$store.getters.isAuthenticated
  }

  logout() {
    this.$store.dispatch('logout')
    this.$router.push({ name: 'Home' })
  }

  importFile() {
    this.$router.push({ name: 'file-upload' })
  }

  get params() {
    return this.$store.state.params
  }

  get routeName() {
    return this.$route.name
  }

  async exportXLS() {
    try {
      this.loader = 'loading'
      const params = { domain: this.params.domain, searchTags: this.params.searchTags, status: this.params.status }
      const response = await this.$store.state.apiClient.getShopsXLS(params)

      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      const fname = 'shops-' + moment().format('YYYY-MM-DD') + '.xlsx'
      link.setAttribute('download', fname)
      document.body.appendChild(link)
      link.click()
      this.loader = ''
    } catch (err) {
      console.log('error: ', err)
      this.loader = ''
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .router-link-exact-active {
  text-decoration: none;
}

@media (min-width: 1440px) {
  .container {
    max-width: 1440px;
  }
}
</style>
